import setTrackingAttributes from './_setTrackingAttributes';

const footerNavDiv = document.querySelector('.o-primaryFooter__links');
const secFooterNavDiv = document.querySelector('.m-secondaryFooter__links');

const footerSubLinks = footerNavDiv.querySelectorAll("[id^='menu-item']");
const secFooterLinks = secFooterNavDiv.querySelectorAll("[id^='menu-item']");

// set the data trackers for the footer nav
Array.from(footerSubLinks).forEach((item) => {
  setTrackingAttributes(item.children[0], 'Navigation', 'Primary Footer');
});

// set the data trackers for the sec footer nav
Array.from(secFooterLinks).forEach((item) => {
  setTrackingAttributes(item.children[0], 'Navigation', 'Secondary Footer');
});

// nav footer subscription button
const footerDiv = document.querySelector('.o-footer');
const footerSubButton = footerDiv.querySelector('.a-btn');

// set the data tracker for the footer subscription button
if (footerSubButton) {
  setTrackingAttributes(
    footerSubButton,
    'CTA',
    'Primary Footer',
    '',
    'Sign up Email',
  );
}

// social icons
// make sure the following array has the correct order
const iconActions = [
  'Click Instagram Icon',
  'Click Twitter Icon',
  'Click Facebook Icon',
];

const iconDiv = document.querySelector('.o-primaryFooter__icons');
if (iconDiv) {
  Array.from(iconDiv.children).forEach((icon, index) => {
    setTrackingAttributes(
      icon,
      'Navigation',
      'Primary Footer',
      iconActions[index],
    );
  });
}
